import customFetch from "~/composables/custom-fetch";
import endpoints from "~/shared/config/api";
import type {IAuthSuccessData, ILogin} from "~/shared/interfaces/auth";

const {auth} = endpoints;

async function loginUser(loginForm: ILogin) {
  const {data: authSuccessData, success, errors, status} = await customFetch<IAuthSuccessData>(auth.login(loginForm));

  if (success && authSuccessData) {
    const {expires, accessToken, user} = authSuccessData;
    const cookieSettings = {
      expires: new Date(expires)
    }
    const token = useCookie('token', cookieSettings);
    const userInfo = useCookie('user', cookieSettings);

    token.value = accessToken;
    userInfo.value = JSON.stringify(user);
  }

  return {
    authSuccessData,
    success,
    errors,
    status
  }
}

export default loginUser
